import React, { useMemo } from 'react';
import { Box, Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

/**
 * Componente que muestra un indicador de estado (Advertencia o Éxito)
 * con colores e iconos dinámicos basados en el "type".
 *
 * @param {('Warning'|'Success'|'Crop')} type - El tipo de estado.
 * @param {string} message - El mensaje a mostrar.
 */
const StatusIndicator = ({ type, message, customIcon }) => {
  const theme = useTheme();
  const isLight = useMemo(() => theme.palette.type === 'light');
  const styleConfig = React.useMemo(() => {
    switch (type) {
      case 'Danger':
        return {
          color: '#D32F2F',
          backgroundColor: '#FEE8E8',
          borderColor: '#D32F2F',
        };
      case 'Info':
        return {
          color: '#1976D2',
          backgroundColor: '#E7F2FF',
          borderColor: '#1976D2',
        };
      case 'Warning':
        return {
          color: '#f1b000',
          backgroundColor: '#fbe7b3',
          borderColor: '#f1b000',
        };
      case 'Success':
      default:
        return {
          color: '#1A7A1F',
          backgroundColor: '#E6F8E8',
          borderColor: '#1A7A1F',
        };
    }
  }, [type]);

  const IconComponent = customIcon;
  const color = styleConfig.color;
  const backgroundColor = styleConfig.backgroundColor;

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '6px 12px',
        borderRadius: '10px',
        border: `1px solid ${color}`,
        backgroundColor: isLight ? backgroundColor : 'transparent',
        color: color,
        fontWeight: 'bold',
        fontSize: '1rem',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
        gap: 3,
        justifyContent: 'center',
        width: '130px',
      }}
    >
      {
        customIcon && (
          <IconComponent 
            style={{ 
              marginRight: 1, 
              fontSize: '1rem'
            }} 
          />
        )
      }
      
      <Typography
        variant="body1" 
        style={{ 
          color: color, 
          lineHeight: 1,
          fontWeight: 500,
          fontSize: '0.75rem'
        }}
      >
        {message}
      </Typography>
    </Box>
  );
};

export default StatusIndicator;